const tmpl = (process.env.VUE_APP_APP_CODE != '' && process.env.VUE_APP_APP_CODE != "undefined" ? process.env.VUE_APP_APP_CODE : "mobile3");
//const tmpl = "dark";
export default tmpl